export default "__VITE_ASSET__C38f$EVU__"